<template>
  <div class="row align-items-center">
    <div class="col-md-5">
      <list-user
        autocomplete
        class="w-100"
        label="Pasajero"
        name="passenger"
        data-cy="passenger"
        data-vv-as="pasajero"
        v-model="passengerForm.passenger"
        ref="passenger"
        :danger="errors.has('custom-document-part-4.passenger')"
        :danger-text="errors.first('custom-document-part-4.passenger')"
        v-validate="'required'"
      />
    </div>
    <div class="col-md-4 mt-4">
      <b-button
        data-cy="add-passenger-button"
        variant="primary"
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        @click="addPassenger()"
      >
        Agregar Pasajero
      </b-button>
    </div>
  </div>
</template>
<script>
import Ripple from 'vue-ripple-directive';

import ListUser from '@/febos/chile/lists/components/ListUser';

export default {
  directives: {
    Ripple
  },
  components: {
    ListUser
  },
  data() {
    return {
      passengerForm: {
        passenger: ''
      }
    };
  },
  methods: {
    async validateForm(scope) {
      const result = await this.$validator.validateAll(scope);
      return !!result;
    },
    async addPassenger() {
      const isValid = await this.validateForm('custom-document-part-4');
      if (!isValid) {
        return;
      }

      const dataPassenger = this.$refs.passenger.getOption();
      const row = {
        ...dataPassenger
      };

      this.$emit('add-passenger', row);

      this.passengerForm.passenger = '';
      await this.$validator.reset();
    }
  }
};
</script>
